import queryString from 'query-string';
import React from 'react';

import { QrcodeContainer } from '../../../../containers/QRCode/QRCodeContainer';
import { useIsSsr } from '../../../../hooks/useSSR';
import { FrontPageComponent } from '../components';

const QRCode = () => {
  const isSsr = useIsSsr();
  if (isSsr) {
    return null;
  }

  const queries = queryString.parse(window.location.search);

  const jobAdId = queries[
    Object.keys(queries).find((key) => key.toLowerCase() === 'jobadid')!
  ] as string;
  const displayQRCode = queries[
    Object.keys(queries).find((key) => key.toLowerCase() === 'displayqrcode')!
  ] as string;

  return (
    <>
      {displayQRCode ? (
        <QrcodeContainer jobAdId={jobAdId} />
      ) : (
        <FrontPageComponent jobAdId={jobAdId} />
      )}
    </>
  );
};

export default QRCode;
